<div class="layout-sidebar" id="sidebar" [class.layout-sidebar--rail]="layout.isRail()">
  <div class="layout-sidebar-scroll" id="sidebar-scroll">
    <ul class="layout-menu">
      @for (section of sections(); track $index) {
        <li class="layout-root-menuitem" [class.layout-root-menuitem--open]="showsEntries(section)" [class.layout-root-menuitem--headed]="!!section.title">
          @if (section.title) {
            <!-- Every heading but Home is a dropdown: a click opens or folds the entries under it. In the icon rail the
                 heading is just its icon, and a click unfolds the sidebar with that section open. -->
            @if (isCollapsible(section)) {
              <button
                type="button"
                class="layout-menuitem-root-text layout-menuitem-root-toggle"
                [attr.aria-expanded]="showsEntries(section)"
                [attr.title]="layout.isRail() ? section.title : null"
                [attr.aria-label]="section.title"
                (click)="layout.isRail() ? onRailSection(section) : toggleSection(section)"
              >
                <span class="layout-section-icon" [class.is-current]="sectionIsCurrent(section)" aria-hidden="true"><i [class]="sectionIconClass(section)"></i></span>
                <span class="layout-menuitem-root-label">{{ section.title }}</span>
                <!-- A drawn chevron, not a font glyph: symmetric about the viewBox's centre, so it is dead centre in its chip, open or closed. -->
                <span class="layout-section-toggler" aria-hidden="true">
                  <svg viewBox="0 0 24 24" focusable="false"><path d="M7 9.5l5 5 5-5" /></svg>
                </span>
              </button>
            } @else if (section.isHome && section.items[0]; as home) {
              <!-- The home heading is the link to the page itself (Dashboard), so there is no second entry under it. -->
              <a
                class="layout-menuitem-root-text layout-menuitem-root-link"
                [routerLink]="[home.path]"
                [attr.aria-current]="home.selected ? 'page' : null"
                [attr.title]="layout.isRail() ? section.title : null"
                (click)="layout.closeMobileMenu()"
              >
                <span class="layout-section-icon" [class.is-current]="sectionIsCurrent(section)" aria-hidden="true"><i [class]="sectionIconClass(section)"></i></span>
                <span class="layout-menuitem-root-label">{{ section.title }}</span>
              </a>
            }
          }
          <!-- The list stays in the page so it can slide both ways (open and close); while folded it is
               inert, so its links are out of the tab order and hidden from screen readers. -->
          @if (!section.isHome) {
            <div class="layout-section-body" [class.is-open]="showsEntries(section)" [attr.inert]="showsEntries(section) ? null : ''">
              <ul class="layout-root-submenulist">
                @for (item of section.items; track $index) {
                  <ng-container [ngTemplateOutlet]="menuItemTpl" [ngTemplateOutletContext]="{ $implicit: item }" />
                }
              </ul>
            </div>
          }
        </li>
      }
    </ul>
  </div>
</div>

<!-- The edge handle: a round chevron on the sidebar's edge that follows it, and waits on the rail's edge while the sidebar is folded. -->
<button
  type="button"
  class="layout-sidebar-handle"
  [class.is-folded]="!layout.isMenuOpen()"
  [attr.aria-label]="layout.isMenuOpen() ? 'Hide menu' : 'Show menu'"
  [attr.title]="layout.isMenuOpen() ? 'Hide menu' : 'Show menu'"
  [attr.aria-expanded]="layout.isMenuOpen()"
  (click)="layout.onMenuToggle()"
>
  <!-- A drawn chevron, not an icon-font glyph: its bounding box is centred on the button's centre, so it sits dead centre. -->
  <svg class="layout-sidebar-handle__chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M14.5 7 9.5 12l5 5" />
  </svg>
</button>

<!-- One entry of the side menu: a link to a page, or a group that opens to show the entries below it (any depth). -->
<ng-template #menuItemTpl let-item>
  <li [class.active-menuitem]="!!item.children?.length && item.active">
    @if (item.children?.length) {
      <a
        href="javascript:void(0)"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="!!item.active"
        [attr.title]="layout.isRail() ? item.title : null"
        (click)="toggleGroup($event, item)"
      >
        <i [class]="menuIconClass(item.icon)" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text">{{ item.title }}</span>
        <!-- The same drawn chevron as the section headings, in the same column. -->
        <span class="layout-submenu-toggler" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M7 9.5l5 5 5-5" /></svg>
        </span>
      </a>
      <!-- Like a section's list, this stays in the page so it can slide both ways; while folded it is inert. -->
      <div class="layout-submenu-body" [class.is-open]="!!item.active" [attr.inert]="item.active ? null : ''">
        <ul class="layout-submenu-open">
          @for (child of item.children; track $index) {
            <ng-container [ngTemplateOutlet]="menuItemTpl" [ngTemplateOutletContext]="{ $implicit: child }" />
          }
        </ul>
      </div>
    } @else {
      <!-- Highlight from `selected` (set by syncWithUrl, which also matches nested detail URLs), not routerLinkActive
           with exact matching: that dropped the highlight as soon as a list opened a record. -->
      <a
        tabindex="0"
        [routerLink]="[item.path]"
        [class.active-route]="item.selected"
        [attr.title]="layout.isRail() ? item.title : null"
        (click)="layout.closeMobileMenu()"
      >
        <i [class]="menuIconClass(item.icon)" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text">{{ item.title }}</span>
      </a>
    }
  </li>
</ng-template>
